import { render } from "./DeliveryList.vue?vue&type=template&id=7f7d7c65"
import script from "./DeliveryList.vue?vue&type=script&lang=js"
export * from "./DeliveryList.vue?vue&type=script&lang=js"

import "./DeliveryList.vue?vue&type=style&index=0&id=7f7d7c65&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__